// =============================================
// NODE: SWITCH (MULTIPLAS SAIDAS CONDICIONAIS)
// =============================================
// Arquivo: SwitchNode.tsx
// Descrição: No de decisao com multiplas saidas baseado em condicoes ou valores
// Similar ao Switch do n8n - permite routing complexo
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface SwitchCase {
  id: string;
  label: string;
  value?: string;
  condition?: string;
  operator?: string;
}

interface SwitchNodeProps {
  data: {
    label?: string;
    variable?: string;
    mode?: 'value' | 'condition' | 'regex';
    cases?: SwitchCase[];
    defaultCase?: boolean;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const SwitchNode: React.FC<SwitchNodeProps> = ({ data, selected }) => {
  const cases = data.cases || [];
  const hasDefault = data.defaultCase !== false;
  const totalOutputs = cases.length + (hasDefault ? 1 : 0);

  // Calcular posicoes dos handles de saida
  const getHandlePosition = (index: number) => {
    const spacing = 100 / (totalOutputs + 1);
    return `${spacing * (index + 1)}%`;
  };

  return (
    <div className={`custom-node switch-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="switch-input"
        className="node-handle target-handle"
      />

      <div className="node-icon">
        <i className="fas fa-random"></i>
      </div>

      <div className="node-content">
        <div className="node-label">{data.label || 'Switch'}</div>

        {data.variable && (
          <div className="node-preview">
            <i className="fas fa-code"></i>
            <span>{'{{' + data.variable + '}}'}</span>
          </div>
        )}

        {cases.length > 0 && (
          <div className="node-preview switch-cases">
            <i className="fas fa-list"></i>
            <span>{cases.length} caso{cases.length > 1 ? 's' : ''}{hasDefault ? ' + default' : ''}</span>
          </div>
        )}

        <ActionsBadge actions={data.actions} />
      </div>

      <div className="switch-handles">
        {cases.map((caseItem, index) => (
          <Handle
            key={caseItem.id || `case-${index}`}
            type="source"
            position={Position.Bottom}
            id={`switch-case-${caseItem.id || index}`}
            className="node-handle source-handle switch-case-handle"
            style={{ left: getHandlePosition(index) }}
          >
            <span className="handle-label switch-label">
              {caseItem.label || caseItem.value || `Caso ${index + 1}`}
            </span>
          </Handle>
        ))}

        {hasDefault && (
          <Handle
            type="source"
            position={Position.Bottom}
            id="switch-default"
            className="node-handle source-handle switch-default-handle"
            style={{ left: getHandlePosition(cases.length) }}
          >
            <span className="handle-label switch-label default-label">
              Default
            </span>
          </Handle>
        )}
      </div>
    </div>
  );
};

export default SwitchNode;
